// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"f0f426c7052746c20feb","263":"b59bd860f5dbe79f2772","791":"eb0a34667fb6292fbdb4"}[chunkId] + ".js";
};